
import { Component, Prop, Vue } from "vue-property-decorator";

import Upload from "@/components/Upload.vue";

@Component({
  name: "CComment",
  components: {
    Upload
  }
})
export default class CComment extends Vue {
  @Prop({ required: false }) public value?: string;

  @Prop({ required: false, default: () => 120 })
  public min_height!: number;

  @Prop({ required: false, default: () => false })
  public disabled!: boolean;

  @Prop({ required: false, default: () => false })
  public has_error!: boolean;

  public accept_files: string[] = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
    "application/vnd.ms-excel.sheet.macroenabled.12", // xlsm MacOS|Linux
    "application/vnd.ms-excel.sheet.macroEnabled.12", //xlsm Win
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
    "application/msword", // doc
    "application/vnd.ms-excel", // xlx
    "application/vnd.ms-powerpoint", // ppt
    "application/vnd.oasis.opendocument.text", // odt
    "application/vnd.oasis.opendocument.spreadsheet", // ods
    "application/vnd.oasis.opendocument.presentation", // odp
    "text/plain" // txt
  ];
}
